import PropTypes from 'prop-types';

// Custom tooltip for better display
const PRPieCustomTooltip = ({ active, payload }) => {
    if (active && payload?.length) {
        const { mergedPRs, openPRs, declinedPRs } = payload[0].payload;
        return (
            <div className="custom-tooltip" style={{ backgroundColor: '#fff', border: '1px solid #ccc', padding: '10px', borderRadius: '4px' }}>
                <p className="label" style={{ margin: 0, fontWeight: 'bold' }}>{`${payload[0].payload.developer}`}</p>
                <p className="desc" style={{ margin: 0 }}>Merged PRs: {mergedPRs}</p>
                <p className="desc" style={{ margin: 0 }}>Open PRs: {openPRs}</p>
                <p className="desc" style={{ margin: 0 }}>Declined PRs: {declinedPRs}</p>
            </div>
        );
    }
    return null;
};

PRPieCustomTooltip.propTypes = {
    active: PropTypes.bool,
    payload: PropTypes.array
};

export default PRPieCustomTooltip;